"use strict";

exports.__esModule = true;
exports.FormField = void 0;

var _utils = require("@bydesign-ui/utils");

var _hooks = require("@bydesign-ui/hooks");

var _nestWatcher = require("../../../models/nest-watcher");

var _validate = require("../../../models/validate");

var _util = require("../util");

var _types = require("../types");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FormField = function (_Emitter) {
  _inheritsLoose(FormField, _Emitter);

  function FormField(form, scope, options) {
    var _this;

    _this = _Emitter.call(this) || this;
    _this.id = (0, _utils.guid)();
    _this.validator = new _validate.Validator(_assertThisInitialized(_this));
    var defaultValue = options.defaultValue,
        field = options.field,
        label = options.label,
        initialValue = options.initialValue;
    _this.form = form;
    _this.node = new _hooks.DomNode({
      type: _types.FormNodeType.FIELD,
      field: field,
      id: _this.id
    }, scope);
    _this.field = field;

    var cacheValue = _this.getCacheValue();

    _this.label = label || field;
    _this.initialValue = initialValue;
    _this.defaultValue = defaultValue;
    _this.initialState = true;
    _this.value = cacheValue != null ? cacheValue : defaultValue == null ? initialValue : defaultValue;

    _this.init();

    return _this;
  }

  var _proto = FormField.prototype;

  _proto.updateOptions = function updateOptions(options) {
    var field = options.field,
        label = options.label,
        rules = options.rules,
        defaultValue = options.defaultValue;

    if (field !== this.field) {
      throw new Error('field should not be updated');
    }

    this.label = label || field;
    this.defaultValue = defaultValue;
    this.validator.updateRules(Array.isArray(rules) ? rules : rules != null ? [rules] : []);
  };

  _proto.isField = function isField() {
    return true;
  };

  _proto.isGroup = function isGroup() {
    return false;
  };

  _proto.isRepeat = function isRepeat() {
    return false;
  };

  _proto.getFieldInfo = function getFieldInfo() {
    return _extends({
      field: this.field,
      value: this.value,
      label: this.label,
      path: this.getPath()
    }, this.validator.getValidateInfo());
  };

  _proto.getValidateError = function getValidateError() {
    return {
      label: this.label,
      field: this.field,
      error: this.validator.getValidateInfo().msg,
      value: this.value,
      path: this.getPath()
    };
  };

  _proto.reset = function reset() {
    this.validator.reset();
    this.form.setPathValue(_nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node)), this.defaultValue == null ? this.initialValue : this.defaultValue, false, {
      reset: true
    });
  };

  _proto.getInitialState = function getInitialState() {
    return this.initialState;
  };

  _proto.validate = function validate(trigger) {
    if (trigger === void 0) {
      trigger = 'manual';
    }

    this.validator.updateValue(this.value);
    return this.validator.validate(trigger);
  };

  _proto.getByExpression = function getByExpression(rp) {
    if (!/^\./.test(rp)) {
      return this.form.getPathValue(rp);
    }

    var path = _nestWatcher.NestWatcher.splitKey(this.getPath());

    path.pop();

    while (/^(\.\.\/)/.test(rp)) {
      rp = rp.slice(RegExp.$1.length);
      path.pop();
    }

    if (/^(\.\/)/.test(rp)) {
      rp = rp.slice(RegExp.$1.length);
    }

    return this.form.getPathValue(_nestWatcher.NestWatcher.combineKeys([].concat(path, _nestWatcher.NestWatcher.splitKey(rp))));
  };

  _proto.dispose = function dispose() {
    this.form.unregister(this);
    this.form.unwatch(this.id);
    this.validator.dispose();

    if (this.form.getSaveMemCache()) {
      this.setCacheValue();
    } else {
      this.form.deletePathValue(_nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node)));
    }

    this.node.remove();
  };

  _proto.getValue = function getValue() {
    return this.value;
  };

  _proto.setValue = function setValue(value) {
    this.form.setPathValue(_nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node)), value);
    this.validator.updateValue(value, true);
  };

  _proto.getForm = function getForm() {
    return this.form;
  };

  _proto.getNode = function getNode() {
    return this.node;
  };

  _proto.getPath = function getPath() {
    return _nestWatcher.NestWatcher.combineKeys((0, _util.getRelativeKeys)(this.node));
  };

  _proto.init = function init() {
    var _this2 = this;

    this.form.register(this);
    var value = this.form.getPathValue(this.getPath());

    if (value != null) {
      this.value = value;
    } else {
      this.form.setPathValue(this.getPath(), this.value, true);
    }

    this.validator.updateValue(this.value, false);
    this.form.absoluteWatch(this.id, [_nestWatcher.NestWatcher.combineKeys((0, _util.getNestWatchPath)(this.node))], function (paths, flags) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          var onv = _this2.form.getPathValue(_this2.getPath());

          var nv = onv === undefined ? _this2.initialValue : onv;
          var isNeedUpdate = nv !== _this2.value;

          if (Array.isArray(nv) && Array.isArray(_this2.value) && nv.length === _this2.value.length && nv.length === 0 && !(flags && flags.reset)) {
            isNeedUpdate = false;
          }

          if (isNeedUpdate) {
            _this2.value = nv;
            _this2.initialState = false;

            if (flags && flags.reset) {
              _this2.initialState = true;

              _this2.validator.reset();

              resolve(_this2.value);
            } else {
              _this2.emit('repaint');

              resolve(_this2.validate('change'));
            }
          }
        }, 0);
      });
    });
    this.validator.addListener('change', function (result) {
      _this2.form.dispatchValidateResult(_this2.id, _this2.node, result);

      _this2.emit('repaint');
    });
  };

  _proto.getCache = function getCache() {
    var node = this.node.parentNode;

    while (node) {
      var _node$getValue = node.getValue(),
          cache = _node$getValue.cache;

      if (cache) {
        return cache;
      }

      node = node.parentNode;
    }

    return null;
  };

  _proto.setCacheValue = function setCacheValue() {
    var cache = this.getCache();

    var cachePath = _nestWatcher.NestWatcher.combineKeys((0, _util.getNestCachePath)(this.node));

    if (cache && cachePath) {
      cache.addCache(cachePath, this.value);
    }
  };

  _proto.getCacheValue = function getCacheValue() {
    var cache = this.getCache();

    var cachePath = _nestWatcher.NestWatcher.combineKeys((0, _util.getNestCachePath)(this.node));

    if (cache && cachePath) {
      var cacheValue = cache.getCache(cachePath);

      if (cacheValue != null) {
        return cacheValue;
      }
    }

    return null;
  };

  return FormField;
}(_hooks.Emitter);

exports.FormField = FormField;